import type { MetaFunction } from "react-router";
import ForYou from "@/pages/ForYou";

export const meta: MetaFunction = () => {
  return [
    { title: "AI-Assisted Writing for Creators | Arcitext" },
    {
      name: "description",
      content: "Write better and faster with Arcitext. A context aware AI writing app, that locks in your writing style, and gives you personalized feedback.",
    },
    {
      name: "keywords",
      content: "AI writing for students, user generated content, content creator tools, personal blogging assistant, authentic writing style AI, writing consistency tool",
    },
    {
      tagName: "link",
      rel: "canonical",
      href: "https://www.arcitext.com/for-creators",
    },
  ];
};

// This route uses static pre-rendering
export default function ForCreatorsRoute() {
  return <ForYou />;
}
